import React from 'react';
import * as css from './EmptyCard.css';

interface EmptyCardProps {
    image: string;
    title: string;
    description?: string;
    children?: React.ReactNode;
    imageAlt?: string;
    bordered?: boolean;
    compact?: boolean;
}

function EmptyCard({image, title, description, children, imageAlt = '', bordered = true, compact = false}: EmptyCardProps) {
    return (
        <css.card $bordered={bordered} $compact={compact} $hasActions={!!children}>
            <css.content>
                <css.image src={image} alt={imageAlt} $compact={compact} />
                <css.title>{title}</css.title>
                {description && <css.description>{description}</css.description>}
            </css.content>
            {children && <css.actions>{children}</css.actions>}
        </css.card>
    );
}

export default EmptyCard;
